import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "archive",
  "use": "archive-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\" id=\"archive\">\n<path d=\"M15.405 3.9225L14.3625 2.6625C14.16 2.4075 13.8525 2.25 13.5 2.25H4.5C4.1475 2.25 3.84 2.4075 3.63 2.6625L2.595 3.9225C2.3775 4.1775 2.25 4.515 2.25 4.875V14.25C2.25 15.075 2.925 15.75 3.75 15.75H14.25C15.075 15.75 15.75 15.075 15.75 14.25V4.875C15.75 4.515 15.6225 4.1775 15.405 3.9225ZM9 13.125L4.875 9H7.5V7.5H10.5V9H13.125L9 13.125ZM3.84 3.75L4.4475 3H13.4475L14.1525 3.75H3.84Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol